<template>
  <div class="animations-wrapper">
    <ul class="animations-list">
      <li class="animations-item"
          v-for="(item, key) in data"
          :class="[
            {relative: key === 0}, startAnimation ? item.direction : '',
            item.type && item.type === 'mask' ? 'animations-item-mask' : '',
            item.maskDirection ? item.maskDirection : '',]"
          :style="`${'transition-duration:' + item.duration +'s; ' + 'transition-delay:' + item.delay +'s;'}`" :key="key">
        <img class="animations-img" :class="{'animations-img--ie' : isIE}" :src="item.src"
             :style="`${'transition-duration:' + item.duration +'s; ' + 'transition-delay:' + item.delay +'s;'}`" alt="">
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

export default {
  name: 'GraphAnimation',
  props: {
    data: {
      type: [Array, Object],
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      startAnimation: false,
      scene: {}
    };
  },
  computed: {
    ...mapState(['userAgent']),
    isIE() {
      return this.userAgent.browser.name === 'ie';
    }
  },
  methods: {
    initScene() {
      this.scene = new ScrollMagic.Scene({
        triggerElement: this.$el,
        triggerHook: 0.8,
        reverse: false
      })
      // .addIndicators()
      .addTo(window.animationsScrollController)
      .on('enter', (event) => {
        this.startAnimation = true;
        this.scene.destroy()
      });

      if (this.$route.query.screentest) {
        this.startAnimation = true;
      }
    },
    clearScenes() {
      this.scene.destroy()
    }
  },
  created() {
    window.animationsScrollController = new ScrollMagic.Controller();
  },
  mounted() {
    this.initScene();
  },
  destroyed(){
    this.clearScenes();
  }
};
</script>

<style lang="scss">
.animations-wrapper {
  overflow: hidden;
}

.animations-list {
  position: relative;
  padding: 0;
  margin: 0;
}

.animations-item {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  //
  display: flex;
  flex-direction: column;

  &.animated {
    opacity: 1;
  }

  &.relative {
    position: relative;
  }

  .screentest & {
    opacity: 1;
  }

  .mobile-notFull & {
    align-items: center;
  }
}

.animations-img {
  width: 100%;
  height: 100%;

  &--ie {
    width: 100%;
    height: 100%;
    max-height: 500px;
    @include media("<desktop") {
      max-height: 400px;
    }
  }

  .mobile-notFull & {
    width: 70%;
  }
}

.animations-item-mask {
  overflow: hidden;
  opacity: 1;

  .animations-img {
    transition: inherit;
  }

  &.fromLeft {
    transform: translate3d(-100%, 0, 0);

    .animations-img {
      transform: translate3d(100%, 0, 0);
    }

    &.animated {
      transform: translate3d(0, 0, 0);

      .animations-img {
        transform: translate3d(0, 0, 0);
      }
    }
  }

  &.fromRight {
    transform: translate3d(100%, 0, 0);

    .animations-img {
      transform: translate3d(-100%, 0, 0);
    }

    &.animated {
      transform: translate3d(0, 0, 0);

      .animations-img {
        transform: translate3d(0, 0, 0);
      }
    }
  }

  &.fromTop {
    transform: translate3d(0, -100%, 0);

    .animations-img {
      transform: translate3d(0, 100%, 0);
    }

    &.animated {
      transform: translate3d(0, 0, 0);

      .animations-img {
        transform: translate3d(0, 0, 0);
      }
    }
  }

  &.fromBottom {
    transform: translate3d(0, 100%, 0);

    img {
      transform: translate3d(0, -100%, 0);
    }

    &.animated {
      transform: translate3d(0, 0, 0);

      img {
        transform: translate3d(0, 0, 0);
      }
    }
  }
}

.screentest .animations-img {
  transition-delay: 0s !important;
  transform: translate3d(0, 0, 0) !important;
}
</style>
